import React from "react";
import VerficationSearch from "../../../../components/Settings/Verification/VerificationSearch";
import VerificationDetails from "../../../../components/Settings/Verification/VerificationDetails";
import { verificationDetailsMapper } from "../../../../services/Settings/Verification/verificationDetailsMapper";
import CorpAddress from "../../../../components/Settings/Verification/CorpAddress";
import AssociatedGSTs from "../../../../components/Settings/Verification/AssociatedGSTs";
import { useDispatch, useSelector } from "react-redux";
import { verifyThisGST } from "../../../../redux/features/verifyPAN/verifyPAN";

const GstVerification = () => {
  const dispatch = useDispatch();
  const verifiedGST = useSelector((state) => state.verify.verifyGST);

  return (
    <div className="mt-24 w-screen">
      <div className="fixed w-4/5 right-0 left-0 m-auto">
        <VerficationSearch
          placeholder={"Enter GSTIN number"}
          dispatchFn={verifyThisGST}
        />
      </div>
      {verifiedGST?.status ? (
        <>
          <div className="flex h-screen justify-center pt-40 mx-auto w-4/6">
            <VerificationDetails
              data={verifiedGST?.gstin_details}
              template={verificationDetailsMapper["GST Verification"]}
            />
          </div>
          <div className="flex h-screen justify-center mx-auto w-4/6">
            <CorpAddress address={verifiedGST?.gstin_details?.address} />
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-10 h-screen items-center pt-40 mx-auto w-2/6">
          <div className="flex">
            <img
              src={require("../../../../assets/Settings/Verification/no_data.png")}
              alt=""
              srcSet=""
            />
          </div>
          <div
            className="text-1xl 3xl:text-2xl 5xl:text-3xl 6xl:text-4xl text-center w-full
              text-white antialiased"
          >
            Enter GST number in the search bar, to fetch the verified GST
            details.
          </div>
        </div>
      )}
    </div>
  );
};

export default GstVerification;
